<template lang="pug" src="./html/ShanghaiCabRide.pug"></template>

<script>

  import Vue from 'vue'
  import ArticleItemBase from './ArticleItemBase'

  const ShanghaiCabRideBody = () => import(/* webpackChunkName: "shanghaiC\-cabride" */ './ShanghaiCabRide-Body')

  Vue.component('ShanghaiCabRideBody', ShanghaiCabRideBody)

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setBody('ShanghaiCabRideBody')
    }
  }
</script>

<style lang="sass" src="./style/ArticleItem.sass"></style>

<style scoped>
    .article-item {
        background-color: #F5F5F5;
        color: #666666;
    }
    .article-item h1 {
        color: #2E170E;
    }
</style>

<style>
    #app.didi-chinas-uber #top-header {
        background-color: #FD804A;
    }
    #app.didi-chinas-uber #load-anim {
        stroke: #2E170E;
    }
</style>
